<script setup lang="ts">
import DRBtnIcon from "@/components/UI/DRBtnIcon.vue";
import DREditTextDialog from "@/components/UI/feedbacks/DREditTextDialog.vue";
import { useUpdateMetadataDetector } from "@/stores/queries/metadata.query";
import type { MetadataDetector } from "@/types";
import { ref } from "vue";

const props = defineProps<{
  metadataDetector: MetadataDetector;
}>();

const { mutateAsync: updateMetadataDetector, isPending: isUpdating } =
  useUpdateMetadataDetector();

const editing = ref(false);

const rules = [
  {
    validator: (value: string) => !!value.trim()?.length,
    message: "La description ne peut pas être vide",
  },
];

const confirmUpdatePrompt = async (prompt: string) => {
  await updateMetadataDetector(
    {
      id: props.metadataDetector.id,
      prompt,
    },
    {
      onSuccess: () => {
        editing.value = false;
      },
    }
  );
};
</script>

<template>
  <div v-loading="isUpdating" class="d-flex align-items-center gap-3">
    <div class="flex-grow-1 column text-truncate pe-3">
      <div class="fw-bold pb-1">$ - {{ metadataDetector.label }}</div>
      <div class="w-100 text-grey ms-4 text-truncate">
        {{ metadataDetector.prompt }}
      </div>
    </div>
    <div class=" ">
      <DRBtnIcon
        @click="editing = true"
        variant="flat"
        :size="30"
        icon="bi-pencil-square"
      />
    </div>
  </div>
  <DREditTextDialog
    v-model="editing"
    :title="metadataDetector.label"
    :value="metadataDetector.prompt"
    description
    :placeholder="
      $t('dashboard:templates.drawer.sections.editDynamicFields.placeholder')
    "
    :label="$t('dashboard:templates.drawer.sections.editDynamicFields.label')"
    :rules="rules"
    textarea
    @confirm="confirmUpdatePrompt($event)"
  />
</template>

<style lang="scss" scoped>
.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
